import { authInstance, noAuthInstance } from './axios/index';
import { reservationRequest } from './reservationIdGuard';
import qs from 'qs';

const manageService = {
  // 여행사 중복체크
  travelCheck: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/travel/check?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return noAuthInstance(requestOptions);
  },
  //호텔 중복 체크
  hotelCheck: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/hotel/check?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return noAuthInstance(requestOptions);
  },
  //호텔명 중복 체크 (사업자 등록증 X)
  hotelNameCheck: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/hotel/name/check?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 조회 AutoComplete
  getTravelAgencies: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/travel/autocomplete/name?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return noAuthInstance(requestOptions);
  },
  //호텔 조회 AutoComplete
  getHotels: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/autocomplete/name?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return noAuthInstance(requestOptions);
  },
  // 여행사 조회(상세) - 여행사 아이디
  getTravelDetail: (travelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/travel/${travelId}`,
    };
    return authInstance(requestOptions);
  },
  // 3. 객실 견적 / 예약 문의 관리
  // 견적/예약 가능한 상태 목록 조회 (기준데이터)
  getReservationStatusList: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/reservation/available-work-status/list?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의 생성
  createReservation: (data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/reservation`,
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의 수정
  updateReservation: (manageId, data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/reservation/${manageId}`,
      data: JSON.stringify(data),
    };
    return reservationRequest(manageId, requestOptions);
  },
  // 견적/예약 문의 취소요청건 철회
  updateRollbackCancelRequest: (manageId) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/reservation/${manageId}/rollback-cancel-request`,
    };
    return reservationRequest(manageId, requestOptions);
  },

  // 견적/예약 문의 목록 조회 (페이징)
  getReservationList: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/reservations?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의 단일(상세) 조회
  getReservationInfo: (manageId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/reservation/${manageId}`,
    };
    return reservationRequest(manageId, requestOptions);
  },
  // 견적/예약 문의 단일(상세) 조회
  getReservationWorkHistories: (manageId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/reservation/${manageId}/work-histories`,
    };
    return reservationRequest(manageId, requestOptions);
  },
  // HOTEL-002: 호텔이 현재 확정 예약과 여행사의 열린 변경안을 한 화면에서 비교한다.
  getReservationChangeOverview: (manageId) => reservationRequest(manageId, {
    method: 'GET',
    url: `/api/manage/v1/reservation/${manageId}/change-overview`,
    useToast: false,
  }),
  // HOTEL-002: 신규 요금이 완비되어 변경 금액을 계산할 수 있는 객실만 조회한다.
  getEligibleRoomTypes: (manageId) => reservationRequest(manageId, {
    method: 'GET',
    url: `/api/manage/v1/reservation/${manageId}/eligible-room-types`,
    useToast: false,
  }),
  // HOTEL-002: 호텔이 여행사가 제출한 변경안을 승인해 금액 계산 단계로 넘긴다.
  approveReservationChangeRequest: (manageId, requestId, data) => reservationRequest(manageId, {
    method: 'POST',
    url: `/api/manage/v1/reservation/${manageId}/change-requests/${requestId}/approve`,
    data: JSON.stringify(data),
    useToast: false,
  }),
  // HOTEL-002: 호텔이 사유를 남기고 변경안을 종료한다.
  rejectReservationChangeRequest: (manageId, requestId, data) => reservationRequest(manageId, {
    method: 'POST',
    url: `/api/manage/v1/reservation/${manageId}/change-requests/${requestId}/reject`,
    data: JSON.stringify(data),
    useToast: false,
  }),
  // HOTEL-002: 호텔이 가능한 조건을 안내하고 여행사에 재수정을 요청한다.
  reviseReservationChangeRequest: (manageId, requestId, data) => reservationRequest(manageId, {
    method: 'POST',
    url: `/api/manage/v1/reservation/${manageId}/change-requests/${requestId}/revise`,
    data: JSON.stringify(data),
    useToast: false,
  }),
  // HOTEL-002: 캔슬 차지가 포함된 최종 목표 총액을 새 불변 금액 버전으로 저장한다.
  adjustReservationAmount: (manageId, data) => reservationRequest(manageId, {
    method: 'POST',
    url: `/api/manage/v1/reservation/${manageId}/amounts/adjust`,
    data: JSON.stringify(data),
    useToast: false,
  }),
  // HOTEL-002: 최신 금액의 캔슬 차지만 바꾼 새 불변 금액 버전을 저장한다.
  updateReservationCancelCharge: (manageId, data) => reservationRequest(manageId, {
    method: 'PUT',
    url: `/api/manage/v1/reservation/${manageId}/amounts/cancel-charge`,
    data: JSON.stringify(data),
    useToast: false,
  }),
  // 견적/예약 문의 일괄 컨펌 요청 알림 발송
  putReservationConfirmRequests: (data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/reservation/work-status/confirm-requests/send-alarm`,
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },

  // 호텔 여행사 그룹 관리 단건 조회 - 호텔 검색 상세
  getRateGroup: (hotelId, travelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/travel/${travelId}/rate-group`,
      useToast: false,
    };
    return authInstance(requestOptions);
  },
  // 5. 호텔 PMS 엑셀 포멧 임포트 (기예약건)
  // 프리뷰 - 산화정보기술 - WINGS PMS 엑셀 업로드 포맷 다운로드
  getPmsWingsImportFormat: () => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/pms-rez/hotel/pms-wings-import-format.xlsx`,
      responseType: 'blob',
      timeout: 60 * 1000,
    };
    return authInstance(requestOptions);
  },
  // 프리뷰 - 산화정보기술 - WINGS PMS 기예약건 엑셀 일괄 등록 (엑셀 업로드)
  uploadPmsHotelExcel: (hotelId, deviceId, data, setUploadLoading) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/pms-rez/hotel/${hotelId}/${deviceId}/pms-wings-import.xlsx`,
      headers: { 'Content-type': 'multipart/form-data' },
      timeout: 5 * 60 * 1000,
      data: data,
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / (progressEvent?.total ?? 1),
        );
        setUploadLoading && setUploadLoading(percentage);
      },
    };
    return authInstance(requestOptions);
  },
  // 프리뷰 - 호텔 PMS 기예약 업로드건 전체 실제 견적/예약 문의에 저장
  allUploadPmsHotel: (hotelId, deviceId) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/pms-rez/hotel/${hotelId}/${deviceId}/reservation/all-upload`,
    };
    return authInstance(requestOptions);
  },
};

export default manageService;
